const config = require("./env");

const environment = {
  baseUrl: config.default.baseUrl,
  country: config.default.country
};

export default environment;
